import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';

import { changeHead } from '../redux/head/headActions';
import { fetchDocuments, searchDocuments } from '../redux/content/contentActions';

import { MLoader } from '../components/molecules';
import { ODocuments, OSearchFilters } from '../components/organisme';
import pageConfig from '../config/page.config';

const mapStateToProps = state => ({
	items: state.content.documents,
	isFetching: state.content.isFetching,
	fetchingSucceeded: state.content.fetchingSucceeded,
});

class DocumentsPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			items: [],
			isFetching: true,
		};
	}

	componentDidMount() {
		this.bindHandles();
		this.props.fetchDocuments();
		this.props.changeHead({
			id: pageConfig.documents.id,
			title: this.props.intl.formatMessage({ id: pageConfig.documents.title }),
			description: this.props.intl.formatMessage({ id: pageConfig.documents.description }),
			showSocialMedia: true,
		});
	}

	componentWillReceiveProps(props) {
		for (const key in this.state) {
			if (key in props && props[key] !== this.state[key]) {
				this.setState({ [key]: props[key] });
			}
		}
	}

	bindHandles() {
		this.handleSearch = this.handleSearch.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.bounce = this.bounce.bind(this);
	}

	handleSearch(search) {
		if (!search) {
			this.props.fetchDocuments();
		}

		this.props.searchDocuments(search);
	}

	handleChange(search) {
		if (!search || search === ' ') {
			this.props.fetchDocuments();
			return;
		}

		this.bounce(search);
	}

	bounce(search) {
		clearTimeout(this.timer);

		this.timer = setTimeout(() => this.handleSearch(search), 500);
	}

	render() {
		let content = <MLoader className="article--loader " />;

		if (!this.state.isFetching) {
			content = <ODocuments items={this.state.items} />;
		}
		return (
			<section className="section-xx">
				<OSearchFilters
					onChange={this.handleChange}
					onClick={this.handleSearch}
				/>
				<article className="layout-body--fill">
					{content}
				</article>
			</section>
		);
	}
}

DocumentsPage.propTypes = {
	fetchDocuments: PropTypes.func.isRequired,
	searchDocuments: PropTypes.func.isRequired,
	changeHead: PropTypes.func.isRequired,
};

export default withRouter(connect(mapStateToProps, {
	fetchDocuments,
	searchDocuments,
	changeHead,
})(injectIntl(DocumentsPage)));



// WEBPACK FOOTER //
// ./src/pages/documents.page.js